import { PADDING_INPUT_SET_TYPES } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/StylingMode/CustomMode/ButtonStyle/constants/paddings';

export const getDisplayedPaddingInputs = (type: PADDING_INPUT_SET_TYPES) => {
  switch (type) {
    case PADDING_INPUT_SET_TYPES.ALL:
      return ['top', 'right', 'bottom', 'left'];
    case PADDING_INPUT_SET_TYPES.VERTICAL:
      return ['top', 'bottom'];
    case PADDING_INPUT_SET_TYPES.HORIZONTAL:
      return ['right', 'left'];
    default:
      return undefined;
  }
};
